import { render, staticRenderFns } from "./scorecard-order-standard-step2.vue?vue&type=template&id=4b669feb&scoped=true"
import script from "./scorecard-order-standard-step2.vue?vue&type=script&lang=js"
export * from "./scorecard-order-standard-step2.vue?vue&type=script&lang=js"
import style0 from "./scorecard-order-standard-step2.vue?vue&type=style&index=0&id=4b669feb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b669feb",
  null
  
)

export default component.exports